import React, { useEffect, useState } from 'react'
import styles from './DigitalInstrumentalCluster_Coral.module.css'
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import { BsDownload } from 'react-icons/bs';
import { FaDownload } from 'react-icons/fa';
import useExcelDownload from '../../../hook/useExelDownload';

function TopBottomPerformingVehicles_Coral(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const downloadExcel = useExcelDownload()
  const [data, setData] = useState(null);




  useEffect(() => {

    const url = API_URL_MAIN + `coral_dic/${props.tableData.apiEnd}${showAll ? '_all' : ''}`


    fetchData(
      {
        url: url,
        body: { filterdata: props.gloablfilter },
      },
      appyData
    );
  }, [props.gloablfilter, showAll]);


  const downloadHandle = () => {
    let title = props.tableData.Tabtitle

    let formData = vehicleDetails?.map((ele, key) => ({
      [title]: (props.tableData.apiEnd === 'faulty_ECU_vehicles') ? ele.key : ele._source.vehicleId,
      [getKeyName()]: getValue(ele)
    }))

    function getKeyName() {

      let apiEnd = props.tableData.apiEnd
      if (apiEnd === "battery_temp_vehicles") {
        return "Temp"
      }
      if (apiEnd === "motor_temp_vehicles") {
        return "Temp"
      }
      if (apiEnd === "lowest_SOC_vehicles") {
        return "Value"
      }
      if (apiEnd === "faulty_ECU_vehicles") {
        return "Count"
      }

      return "Value";
    }

    function getValue(ele) {
      let apiEnd = props.tableData.apiEnd
      if (apiEnd === "battery_temp_vehicles") {
        return ele?._source.BMS_Max_Cell_Temperature?.toFixed(1);
      }
      if (apiEnd === "motor_temp_vehicles") {
        return ele?._source.MCU_Motor_Temperature?.toFixed(1);
      }
      if (apiEnd === "lowest_SOC_vehicles") {
        return ele?._source.State_of_Charge_SOC?.toFixed(1);
      }
      if (apiEnd === "faulty_ECU_vehicles") {
        return ele?.fault_condition_matches.value?.toFixed(1);
      }
      return null;
    }

    downloadExcel(formData, title)
  }

  const appyData = (data) => {

    setVehicleDetails(data);
  };

  if (!Array.isArray(vehicleDetails)) {
    return <div className="text-danger">Failed to load vehicle details</div>;
  }


  return (
    <div className={`${styles.fullTable} p-0`}>
      <div className={`mx-2 align-items-center ${styles.tableTitles}`}>
        <div className="text-start">{props.tableData.Tabtitle}</div>
        <div className='d-flex align-items-center'>
          <div className={`form-check form-switch  ${styles.customSwitch}`}>
            <input
              className={`form-check-input ${styles.switchInput}`}
              type="checkbox"
              id="vehicleSwitch"
              checked={showAll}
              onChange={() => setShowAll(!showAll)}
            />
          </div>
          <div
            className={`text-start ml-3 cursor-pointer custom-Btn-animation`}
            onClick={() => downloadHandle()}
          ><FaDownload /></div>
        </div>
      </div>
      {/* <div className='d-flex align-items-center justify-content-between me-3'>
        <div className="text-start ml-3"><FaDownload /></div>
        <div className={`form-check form-switch  ${styles.customSwitch}`}>
          <input
            className={`form-check-input ${styles.switchInput}`}
            type="checkbox"
            id="vehicleSwitch"
            checked={showAll}
            onChange={() => setShowAll(!showAll)}
          />
        </div>
      </div> */}

      <div className={`m-0 ${styles.topBottomPerformingTables}`}>
        <table className="table table-striped">
          <thead style={{ backgroundColor: 'rgb(53, 134, 150)', color: 'rgb(255, 255, 255)', position: 'sticky', top: '0px' }}>
            <tr>
              <th scope="col">{props.tableData.tabCol1}</th>
              <th scope="col">{props.tableData.tabCol2}</th>
            </tr>
          </thead>
          <tbody>
            {vehicleDetails?.map((ele, i) => (
              <tr>
                <td scope="row" className="hand_geture" onClick={() => {
                  if (props.tableData.apiEnd === 'faulty_ECU_vehicles') {
                    props.singleVinSelected(ele.key);
                  } else {
                    props.singleVinSelected(ele._source.vehicleId);
                  }
                }}>
                  {(props.tableData.apiEnd === 'faulty_ECU_vehicles') ? ele.key : ele._source.vehicleId}
                </td>
                <td>
                  {props.tableData.apiEnd === 'battery_temp_vehicles' && ele._source.BMS_Max_Cell_Temperature}
                  {props.tableData.apiEnd === 'motor_temp_vehicles' && ele._source.MCU_Motor_Temperature}
                  {props.tableData.apiEnd === 'lowest_SOC_vehicles' && ele._source.State_of_Charge_SOC}
                  {props.tableData.apiEnd === 'faulty_ECU_vehicles' && ele.fault_condition_matches.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TopBottomPerformingVehicles_Coral
